import React, { useState } from 'react';
import { TextField, IconButton, InputAdornment } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

function EditableTextField({ value: initialValue, onSave }) {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(initialValue);
  const [mouseOver, setMouseOver] = useState(false);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSave = () => {
    setIsEditing(false);
    if (onSave) {
      onSave(value);
    }
  };

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleBlur = () => {
    handleSave();
  };

  return (
    <div
      onMouseEnter={() => setMouseOver(true)}
      onMouseLeave={() => setMouseOver(false)}
      style={{ display: 'inline-flex', alignItems: 'center', paddingRight: 40 }}
    >
      {isEditing ? (
        <TextField
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          autoFocus
          variant="outlined"
          size="small"
          fullWidth
          InputProps={{
            
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={handleSave}
                  style={{ visibility: mouseOver ? 'visible' : 'hidden' }}
                >
                  <EditIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      ) : (
        <TextField
          sx={{ "& fieldset": { border: 'none' } }}
          value={value}
          variant="outlined"
          size="small"
          InputProps={{
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={handleEditClick}
                  style={{ visibility: mouseOver ? 'visible' : 'hidden' }}
                >
                  <EditIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
          onClick={handleEditClick}
        />
      )}
    </div>
  );
}

export default EditableTextField;
